import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import {
  FacebookShareButtonBox,
  ShareButton,
} from 'components/Listing/FacebookShare/FacebookShare.style'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import Stack from '@careguide/stack'
import { Heading } from '@careguide/typography'

type FacebookShareProps = {
  facebookShareLink: string
}

const facebookIcon = faFacebookF as IconProp

const FacebookShare = ({ facebookShareLink }: FacebookShareProps) => {
  return (
    <Stack gap='2'>
      <Heading as='h2'>Share This Profile</Heading>
      <FacebookShareButtonBox>
        <ShareButton url={facebookShareLink} resetButtonStyle={false}>
          <FontAwesomeIcon style={{ marginRight: 16 }} color='white' icon={facebookIcon} />
          Connect With Facebook
        </ShareButton>
      </FacebookShareButtonBox>
    </Stack>
  )
}

export default FacebookShare
